import * as React from "react";
import { ReactNode } from "react";
import { Route, Routes } from 'react-router-dom';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { PartnersTransactions } from './pages/partners/PartnersTransactions';
import { OperationsListOfPartners } from "./pages/operations/OperationsListOfPartners";
import { OperationsTransactions } from "./pages/operations/OperationsTransactions";
import DashboardGuard from "./guards/DashboardGuard";
import { Login } from "./pages/Login";
import { CreatePassword } from "./pages/CreatePassword";
import CreatePasswordGuard from "./guards/CreatePasswordGuard";

const transactionsIcon = require('../src/assets/icons/transactions-icon.png')
const listOfPartnersIcon = require('../src/assets/icons/partners-icon.png')
const faqIcon = require('../src/assets/icons/faq-icon.png')
const logoutIcon = require('../src/assets/icons/logout-icon.png')


type MenuItem = ItemType & {
  children?: MenuItem[];
  component?: ReactNode;
};

export const partnersRoutes: MenuItem[] = [
  {
    component: <PartnersTransactions />,
    key: '/partners/transactions',
    label: 'Transactions',
    icon: <img src={transactionsIcon} alt="" width="26" />
  },
]

export const operationsRoutes: MenuItem[] = [
  {
    component: <OperationsTransactions />,
    key: '/operations/transactions',
    label: 'Transactions',
    icon: <img src={transactionsIcon} alt="" width="26" />
  },
  {
    component: <OperationsListOfPartners />,
    key: '/operations/list-of-partners',
    label: 'List of partners',
    icon: <img src={listOfPartnersIcon} alt="" width="30" />
  }
]

export const RouteContent: React.FC = () => {
  const result: Array<ReactNode> = [
    <Route element={<Login />} key="/login" path="/login" />,
    <Route
      element={
        <CreatePasswordGuard>
          <CreatePassword />
        </CreatePasswordGuard>
      }
      key="/create-password"
      path="/create-password"
    />
  ];
  // current menu items to display based on account type role
  const menuItems = localStorage.getItem('accountType') === 'partner' ? partnersRoutes : operationsRoutes;

  const dfs = (routes: MenuItem[]) => {
    routes.forEach((item: MenuItem) => {
      result.push(
        <Route
          element={
            <DashboardGuard>
              {item.component}
            </DashboardGuard>
          }
          key={item.key}
          path={item.key?.toString()}
        />
      );
      if (item.children) {
        dfs(item.children);
      }
    });
  };

  dfs(menuItems);

  if (localStorage.getItem('accountType') === 'partner') {
    result.push(
      <Route
        element={
          <DashboardGuard>
            <PartnersTransactions />
          </DashboardGuard>
        }
        key="/partners/transactions"
        path="*"
      />
    );
  } else {
    result.push(
      <Route
        element={
          <DashboardGuard>
            <OperationsTransactions />
          </DashboardGuard>
        }
        key="/operations/transactions"
        path="*"
      />
    );

    result.push(
      <Route
        element={<Login />}
        key="/login"
        path="/login"
      />,
      <Route
        element={<CreatePassword />}
        key="/create-password"
        path="/create-password"
      />,
    );
  }

  dfs(menuItems);

  return <Routes>{result}</Routes>;
};

export const accountMenuItems = [
  {
    key: '/faqs',
    label: 'FAQ',
    icon: <img src={faqIcon} alt="" width="30" />
  },
  {
    key: '/login',
    label: 'Logout',
    icon: <img src={logoutIcon} alt="" width="30" />
  }
]